import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class SelectPopupCompo extends Vue {
    public title: string = 'SelectPopupCompo';

    @Prop({ default: null })
    public data: any;

    @Prop({ default: null })
    public onSelChange!: (val: any) => void;


    public selected: string = '';

    @Prop()
    public show!: boolean;

    public renderCN: boolean = false;
    @Prop()
    public defaultSelect!: string;
    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(globalPudge: any, globalPudgeOld: any) {
        const language = globalPudge.getParam('language')
            ? parseInt(globalPudge.getParam('language') , 10)
            : 0;
        if (language === 1) {
            this.renderCN = false;
        }
        if (language === 0) {
            this.renderCN = true;
        }
    }
    public renderLang(val: string) {
        if (val === 'all' && this.renderCN) {
            return '全部';
        } else {
            return val;
        }
    }
    public created() {
        if (this.defaultSelect) {
         this.selected = this.defaultSelect;
        }
    }

    public changeSel(val: any) {
        this.selected = val;
        this.$emit('selectChange', val);
        this.$emit('onHide');
    }
    public triggerHide() {
        this.$emit('onHide');
    }

}
